import type { ReactNode } from "react";
import { useLocation } from "react-router-dom";

/**
 * Wraps routed content in a keyed container so a subtle fade-in plays on every
 * page change. Opacity-only (no transform) so the fixed navbar keeps working.
 */
export default function PageFade({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-fade">
      {children}
    </div>
  );
}